import Vue from 'vue'
import Router from 'vue-router'
const _import = require('./_import_' + process.env.NODE_ENV);
import Login from '@/views/login'
import clogin from '@/views/clogin'
import MainIndex from '@/views/mainIndex'
import LoginIndex from '@/views/LoginIndex'

import Help from '@/views/help'

import Regist from '@/views/regist'
import Retrievepwd from '@/views/retrievepwd'


import Layout from '@/views/frame/Layout.vue'

/* dashboard */
const Analysis = _import('dashboard/analysis');
const Monitor = _import('dashboard/monitor');
/* form */
const BasicForm = _import('form/basicForm');
const stepForm = _import('form/stepForm');
const AdvancedForm = _import('form/advancedForm');
/* list */
const TableList = _import('list/tablelist');
const BasicList = _import('list/basiclist');
const CardList = _import('list/cardlist');
const Articles = _import('list/articles');
const Projects = _import('list/projects');
const Application = _import('list/application');
/* result */
const Basic = _import('profile/basic');
const Advanced = _import('profile/advanced');
/* result */
const Success = _import('result/success');
const Fail = _import('result/fail');
/* error page */
const Err403 = _import('error/403');
const Err404 = _import('error/404');
const Err500 = _import('error/500');

const OperatorTable = _import('system/operatortable');
const SkillTable = _import('skill/skilltable')
const SkillAudit = _import('skill/skillaudit')
const BotTable = _import('skill/botTable')
const BotDetail = _import('skill/botDetail')
const EntityType = _import('entity/entitytype')
const EntityTable = _import('entity/entitytable')
const EntityDetails = _import('entity/entitydetails')
const Document = _import('document/document')

const ActivityTemplateTable=_import('activity/activityTemplate')
const InterfaceTable=_import('system/interfacetable')
const ActivityTable=_import('activity/activity')



const SimpleParam=_import('param/simple/simpleParam')
const MapParam=_import('param/map/MapParam')
const MapParamField=_import('param/map/MapParamField')
const ListParam=_import('param/list/listParam')
const ListParamField=_import('param/list/listParamField')
const ListParamValue=_import('param/list/listParamValue')
const mock=_import('activity/mock')

const Equitytype=_import('equity/equitytype')
const Equityevent=_import('equity/equityevent')
const Interests=_import('equity/interests')
const Stream=_import('equity/stream')

const Register=_import('register/list')
const Based=_import('based/list')
const BasedAdmin=_import('basedAdmin/listAdmin')
const BasedAdminWx=_import('basedAdmin/listAdminWx')
const Flowpath=_import('flowpath/index')

const Notice=_import('notice/list')
const Complain=_import('complain/list')
const Consumer=_import('consumer/list')
const Permission=_import('permission/list')


const CashList=_import('prize/lottery/cashList')
const DrawList=_import('prize/lottery/drawList')
const Lottery=_import('prize/lottery/list')
const DrawPrize=_import('prize/lottery/drawPrize')
const ExchangePrize=_import('prize/lottery/exchangePrize')

const MyMessage=_import('templateMan/myMessage')
const SendRecord=_import('templateMan/sendRecord')


Vue.use(Router)

/* 路由模板 */
const rout = {
  template: '<router-view></router-view>'
}
/* 常量路由 */
export const constantRouterMap = [
  // {
  //   path: '/login',
  //   component: Login,
  //   hidden: true
  // },
	{
	  path: '/clogin',
	  name: '小营加登录',
	  hidden:true,
	  component: clogin,
	},
  {
    path: '/mainIndex',
    name: '首页',
    hidden:true,
    component: MainIndex,
  },
  
  // {
  //   path: '/loginIndex',
  //   name: '用户中心登录',
  //   hidden: true,
  //   component: LoginIndex,
  // },
  // {
  //   path: '/help',
  //   name: '帮助与支持',
  //   hidden: true,
  //   component: Help,
  // },
  {
    path: '/regist',
    name: '注册',
    hidden: true,
    component: Regist,
  },
  {
    path: '/retrievepwd',
    name: '修改密码',
    hidden: true,
    component: Retrievepwd,
  },


]

/* 异步路由 */
//
export const asyncRouterMap = [
 {
    path: '/flowpath',
    redirect: 'flowpath/index',
    component: Layout,
    name: '活动流程',
    icon: 'compose',
    children: [
      {
        path: 'index',
        component: Flowpath,
        name: '活动流程'
      }
    ],

		 meta: {role: ['admin','ooper','isv']}
  },
  {
    path: '/system',
    redirect: '/system/operator',
    component: Layout,
    sys:1,
    name: '操作员管理',
    icon: 'compose',
    children: [
      {
        path: 'operator',
        component: OperatorTable,
        name: '操作员'
      }
    ],
    meta: {role: ['admin','ooper']}
  },
  {
    path: '/system',
    redirect: '/system/interface',
    component: Layout,
    sys:1,
    name: '接口管理',
    icon: 'compose',
    children: [
      {
        path: 'interface',
        component: InterfaceTable,
        name: '系统接口'
      }
    ],
    meta: {role: ['admin','ooper']}
  },
  {
    path: '/activity',
    redirect: '/activity/activity',
    component: Layout,
    name: '活动管理',
    icon: 'compose',
    hidden: true,
    children: [
      {
        path:'activity',
        component:ActivityTable,
        name:'活动管理'
      },
      {
        path:'mock',
        component:mock,
        name:'测试页面',
        hidden:true
      }

    ],
    meta: {role: ['admin','ooper','isv']}
  },
  {
    path: '/param',
    redirect: '/param/simple',
    component: Layout,
    name: '参数管理',
    icon: 'compose',
    children: [
      {
        path:'simple',
        component:SimpleParam,
        name:'简单参数'      },
      {
        path:'map',
        component:MapParam,
        name:'集合参数'
      },
      {
        path:'mapfield',
        component:MapParamField,
         hidden: true,
        name:'集合参数字段'
      },

      {
        path:'list',
        component:ListParam,
        name:'列表参数'
      },
      {
        path:'listfield',
        component:ListParamField,
        hidden: true,
        name:'列表参数字段'
      },
      {
        path:'listvalue',
        component:ListParamValue,
        hidden: true,
        name:'列表参数值'
      }
    ],
    meta: {role: ['admin','ooper','isv']}
  },
  {
    path: '/equity',
    redirect: '/equity/equitytype',
    component: Layout,
    name: '权益管理',
    icon: 'compose',
    children: [
      {
        path:'equitytype',
        component:Equitytype,
        name:'权益类型'

      },
      {
        path:'equityevent',
        component:Equityevent,
        name:'权益事件',
        hidden:true,
      },
      {
        path:'interests',
        component:Interests,
        name:'权益查询',
      },
      {
        path:'stream',
        component:Stream,
        name:'权益流水查询',
        hidden:true,
      }
    ],
    meta: {role: ['admin','ooper','isv']}
  },
  {
    path: '/prize/lottery',
    redirect: '/prize/list',
    component: Layout,
    name: '奖项管理',
    icon: 'compose',
    children: [
      {
        path:'list',
        component:Lottery,
        name:'奖品管理'
      },
      {
        path:'drawlist',
        component:DrawList,
        hidden:true,
        name:'兑奖管理'
      },
      {
        path:'cashlist',
        component:CashList,
        hidden:true,
        name:'抽奖管理'
      },
			{
        path:'drawPrize',
        component:DrawPrize,
        name:'中奖记录'
      },
      {
        path:'exchangePrize',
        component:ExchangePrize,
        name:'发放流水记录',
				hidden:true,
      },
	  // {
   //      path:'exchangePrize',
   //      component:ExchangePrize,
   //      name:'兑奖奖品设置'
   //    }
    ],
    meta: {role: ['admin','ooper','isv']}
  },
  {
    path: '/register',
    redirect: '/register/list',
    component: Layout,
    name: '签到管理',
    icon: 'compose',
    children: [
      {
        path:'list',
        component:Register,
        name:'签到设置'
      }],
      meta: {role: ['admin','ooper','isv']}
  },
    {
    path: '/based',
    redirect: '/based/list',
    component: Layout,
    name: '活动对接配置',
    icon: 'compose',
    children: [
      {
        path:'list',
        component:Based,
        name:'授权配置'
      }],
      meta: {role: ['admin','ooper','isv']}
  },
  {
    path: '/basedAdmin',
    redirect: '/basedAdmin/listAdmin',
    component: Layout,
    name: '活动对接配置_管理员',
    icon: 'compose',
    children: [
      {
        path:'listAdmin',
        component:BasedAdmin,
        name:'支付宝_配置'
      },{
        path:'listAdminWx',
        component:BasedAdminWx,
        name:'微信_配置',
				hidden:true
      }],
    meta: {role: ['admin']}
  },

  {
    path: '/notice',
    redirect: '/notice/list',
    component: Layout,
    name: '活动基础管理',
    icon: 'compose',
    children: [
      {
        path:'noticeList',
        component:Notice,
        name:'通知查询'
      },
      {
        path:'complainList',
        component:Complain,
        name:'投诉查询'
      },
      {
        path:'activityUserList',
        component:Consumer,
        name:'活动用户'
      },
      {
        path:'permissionList',
        component:Permission,
        name:'活动数据权限'
      }
    ],
      meta: {role: ['admin','ooper']}
  },
    {
    path: '/myMessage',
    redirect: '/templateMan/myMessage',
    component: Layout,
    name: '模板消息管理',
    icon: 'compose',
    children: [
      {
        path:'myMessage',
        component:MyMessage,
        name:'我的模板消息'

      },
      {
        path:'sendRecord',
        component:SendRecord,
        name:'发送记录',
      },
      
    ],
    meta: {role: ['admin','coper']}
  },




]

const router = new Router({
   //mode: 'history',
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js